import React from 'react';

const ProductDetailModal = () => {

  console.log("product Details");
  
  return (
    <>
     <div className="box">
      <div className="outerpopup">
        <div className="innerfirstpopup">
          <img className="imagepopup" src="https://www.ikea.com/images/6a/4f/6a4f63e0656656fad1b7ccf255be6a98.png?f=m" alt="dish that need to be displayed"/>
        </div>  
        <div className="innerfirstpopup">
          <h5 className="product-details-title">Swedish metaballs</h5>
          <h6 className="product-details-desc">For added durability and so you can enjoy the natural expression of the wood, the furniture has been pre-treated with several layers of semi-transparent wood stain. </h6>
          <h1 className="dhs-12">Dhs 12</h1>
          <h5  className="ingredient-data">ingredients</h5>
          <p  className="ingredients">ikas ssmsy hsns gnnshs</p>
          <h5  className="ingredient-data">Calorie</h5>
          <p  className="ingredients">nkdb sgsh hhasks hssj</p>
         </div>
         

        </div>
      </div>
      
    </>
  )
}
export default ProductDetailModal;
